import React, { useEffect, useState } from "react";
import Navsbar from "../components/Navbar/Navsbar";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import $ from "jquery";
import { ArrowUp02Icon } from "hugeicons-react";
import Offline from "./Error/Offline";
import can from "../assets/cana.jpg";
import ScrollToTop from "../utils/ScrollToTop";
import Chatbot from "../components/Chatbot/Chatbot";
// import { motion } from 'framer-motion'

export const Loader = () => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev.length === 3) {
          return "";
        }
        return prev + ".";
      });
    }, 500); // Ajoute un point toutes les 500 ms

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 w-full bg-white z-[200] flex flex-col gap-3 items-center justify-center h-screen">
      <div className="relative">
        <div className="h-24 w-24 rounded-full border-t-8 border-b-8 border-primary border-opacity-40"></div>
        <img
          loading="eager"
          src={can}
          alt={can}
          className="absolute w-[50%] object-cover -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2"
        />
        <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-secondary animate-spin"></div>
      </div>
      <div
        className="text-lg max-md:text-sm font-semibold font-mono text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary"
        style={{ animationDuration: "3s", animationIterationCount: "infinite" }}
      >
        Chambre de Commerce Canada Afrique {dots}
      </div>
    </div>
  );
};



export default function Layouts() {
  const handleScrolle = () => {
    const scrol = $(window).scrollTop();
    if (scrol <= 850) {
      $(".button-scrolltop").addClass("hidden").removeClass("flex");
    } else {
      $(".button-scrolltop").removeClass("hidden").addClass("flex");
    }
  };
  window.addEventListener("scroll", handleScrolle);
  $(document).ready(() => {
    $(".button-scrolltop").on("click", () => {
      $(document).scrollTop(0);
    });
  });

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // const [isLoading, setIsLoading] = useState(true);
  // const location = useLocation();

  // useEffect(() => {
  //   setIsLoading(true); // reset loader à chaque changement de page
  //   const timeout = setTimeout(() => setIsLoading(false), 2000); // ou moins, genre 1000ms
  //   return () => clearTimeout(timeout);
  // }, [location.pathname]); // déclenché à chaque changement d'URL

  // if (isLoading) {
  //   return <Loader />;
  // }

  return (
    <>
    <ScrollToTop />
    <div className="">
      <Navsbar />
      {/* {isOnline ? <div className="w-full"><Outlet /></div> : <Offline />} */}
      <Outlet />
      <Footer />
      <div className="fixed button-scrolltop hidden backdrop-blur-md items-center cursor-pointer justify-center bottom-10 max-md:bottom-5 max-md:right-5 right-10 bg-secondary z-10 bg-opacity-40 hover:bg-opacity-100 text-white w-[50px] transition-none duration-500 rounded-md  h-[45px]">
        <ArrowUp02Icon />
      </div>
      <Chatbot />
    </div>
    </>
  );
}
